const WELCOME_GUIDE_ONBOARDING_TYPE = 'welcomeGuide';

export {
    WELCOME_GUIDE_ONBOARDING_TYPE
};
